import { render, staticRenderFns } from "./ItemGroups.vue?vue&type=template&id=6e354133&scoped=true"
import script from "./ItemGroups.vue?vue&type=script&lang=js"
export * from "./ItemGroups.vue?vue&type=script&lang=js"
import style0 from "./ItemGroups.vue?vue&type=style&index=0&id=6e354133&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e354133",
  null
  
)

export default component.exports